import React from 'react';

import { Direction, Popper } from '~shared/components/Popper';

interface Props {
  label: string;
  delay?: number;
  enablePersistence?: boolean;
  children: React.ReactNode;
  disableArrow?: boolean;
  direction?: Direction;
  isDisabled?: boolean;
  maxContentWidth?: number;
  contentWidth?: number;
  mode?: 'click' | 'hover' | 'context';
}

export function TooltipV2({
  label,
  delay,
  enablePersistence,
  children,
  disableArrow,
  direction,
  isDisabled,
  maxContentWidth = 260,
  contentWidth,
  mode = 'hover',
}: Props) {
  return (
    <Popper
      theme={'dark'}
      mode={mode}
      isDisabled={isDisabled}
      direction={direction ?? 'top'}
      content={
        <div
          style={{
            maxWidth: maxContentWidth,
            width: contentWidth
          }}
          className="break-words font-sans text-center bg-black text-white p-2 rounded-2"
        >
          {label}
        </div>
      }
      enableArrow={disableArrow ? undefined : true}
      delay={delay ?? 200}
      enablePersistence={enablePersistence ? true : undefined}
    >
      {children}
    </Popper>
  );
}
